module.exports = __webpack_public_path__ + "static/media/closeMobile.b626ffb3.svg";